import { Component, OnDestroy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

@Component({
  selector: 'bmd-component',
  // eslint-disable-next-line @angular-eslint/prefer-standalone
  standalone: false,
  styleUrls: ['./bmd.scss'],
  templateUrl: './bmd.html',
})
export class BMDComponent implements OnDestroy {
  apiKey: string;
  subscriptions: Subscription[] = [];

  constructor(private translateService: TranslateService) {}

  ngOnDestroy(): void {
    this.subscriptions.forEach(subscriber => subscriber.unsubscribe());
  }
}
